"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeSegment = exports.DATE_TIME_PICKER_TEST_ID = void 0;
const Col_1 = require("@amzn/atoz-web/Col");
const Text_1 = require("@amzn/atoz-web/Text");
const Hr_1 = require("@amzn/atoz-web/Hr");
const Datepicker_1 = require("@amzn/atoz-web/Datepicker");
const InputWrapper_1 = require("@amzn/atoz-web/InputWrapper");
const Spacer_1 = require("@amzn/atoz-web/Spacer");
const react_1 = __importDefault(require("react"));
const PayCodeSelection_web_1 = require("./PayCodeSelection.web");
const DateManagement_1 = require("../../../../../utils/DateManagement");
exports.DATE_TIME_PICKER_TEST_ID = 'date-time-picker';
const TimeSegment = (props) => {
    const updateInputTimeInPayDataList = (inputTime, isStartTime) => {
        props.setPayDataList((payDataList) => {
            const updatedPayDataList = [...payDataList];
            const prevPayData = payDataList[props.payDataIndex];
            const updatedPayData = isStartTime
                ? Object.assign(Object.assign({}, prevPayData), { beginDateTime: (0, DateManagement_1.getTimeStringFromPopupDatePicker)(inputTime) })
                : Object.assign(Object.assign({}, prevPayData), { endDateTime: (0, DateManagement_1.getTimeStringFromPopupDatePicker)(inputTime) });
            updatedPayDataList[props.payDataIndex] = updatedPayData;
            return updatedPayDataList;
        });
    };
    const updateInputTimeInPayCodeList = (inputTime, isStartTime) => {
        props.setPayCodeList((payCodeList) => {
            const updatedPayCodeList = [...payCodeList];
            const prevPayCode = payCodeList[props.payDataIndex];
            const updatedPayCode = isStartTime
                ? Object.assign(Object.assign({}, prevPayCode), { startDateTime: (0, DateManagement_1.getTimeStringFromPopupDatePicker)(inputTime) })
                : Object.assign(Object.assign({}, prevPayCode), { endDateTime: (0, DateManagement_1.getTimeStringFromPopupDatePicker)(inputTime) });
            updatedPayCodeList[props.payDataIndex] = updatedPayCode;
            return updatedPayCodeList;
        });
    };
    const renderTimeTextInput = (value, isStartTime, onChange) => (react_1.default.createElement(Col_1.Col, { gridGap: "S100", width: "100%" },
        react_1.default.createElement(InputWrapper_1.InputWrapper, { labelText: isStartTime ? 'Start Time' : 'End Time', id: isStartTime ? 'start_time' : 'end_time', "aria-labelledby": isStartTime ? 'start_time format' : 'end_time format', renderLabel: ({ children }) => {
                return (react_1.default.createElement(Text_1.Text, { fontSize: "T100", color: "neutral70" }, children));
            } }, (inputProps) => (react_1.default.createElement(Datepicker_1.PopupDatePicker, Object.assign({}, inputProps, { dataTestId: exports.DATE_TIME_PICKER_TEST_ID, id: 'format', showTime: true, value: value, onChange: (value) => onChange(value, isStartTime) }))))));
    return (react_1.default.createElement(Col_1.Col, { gridGap: "S100" },
        !props.isUpdateSelfClassification && (react_1.default.createElement(PayCodeSelection_web_1.PayCodeSelection, { selectedPayCode: props.isWECoreSelfClassification
                ? props.payData.salaryCodesDescription[0]
                : props.payCodeSummary.payCodeName, setPayDataList: props.setPayDataList, setPayCodeList: props.setPayCodeList, payDataIndex: props.payDataIndex, payCodePolicyInfo: props.payCodePolicyInfo, payCodesInfo: props.payCodesInfo, isWECoreSelfClassification: props.isWECoreSelfClassification, isDisabled: false })),
        props.isWECoreSelfClassification
            ? renderTimeTextInput(props.payData.beginDateTime, true, updateInputTimeInPayDataList)
            : renderTimeTextInput(props.payCodeSummary.startDateTime, true, updateInputTimeInPayCodeList),
        props.isWECoreSelfClassification
            ? renderTimeTextInput(props.payData.endDateTime, false, updateInputTimeInPayDataList)
            : renderTimeTextInput(props.payCodeSummary.endDateTime, false, updateInputTimeInPayCodeList),
        react_1.default.createElement(Spacer_1.Spacer, { height: 10 }),
        react_1.default.createElement(Hr_1.Hr, null)));
};
exports.TimeSegment = TimeSegment;
